<template>
	<div id="crowdx-screen">
		<jumbotron
			:textColor="'#fff'"
			:titleColor="'#fff'"
			:title="$t('crowdxScreen.welcome.title')"
			:description="$t('crowdxScreen.welcome.description')"
			:background="'#1B1B1B'"
			:backgroundImage="'/images/sections/crowdx/header_image.png'"
			:mobileHeight="415"
			:storesLabel="$t('crowdxScreen.welcome.storesLabel')"
			:logoSrc="'/images/logos/crowdx-logo.svg'"
			:logoStyle="{ marginBottom: '47px' }"
			:mobileBackgroundImage="'/images/sections/crowdx/header_image_mobile.png'"
		>
			<!-- 			<template v-slot:chart>
				<chart-component
					v-if="refactoredData"
					:titleText="$t('crowdxScreen.welcome.chart.title')"
					:subtitleText="
						$t('crowdxScreen.welcome.chart.subtitle', {
							value: calculatedLastPrice,
						})
					"
					:infoText="$t('crowdxScreen.welcome.chart.infoText')"
					:chart-data="refactoredData"
					:gradientStartColor="'rgba(237, 133, 50, 0.2)'"
					:gradientEndColor="'rgba(237, 133, 50, 0)'"
					:infoTooltipBackground="'#ED8532'"
				/>
			</template> -->
		</jumbotron>

		<crowdx-white-paper />

		<crowdx-about-section />

		<crowdx-use-cases-section />

		<crowd-funding-at-scale-section
			:bullet-items="[
				$t('crowdxScreen.crowdfundingScale.bullets.0'),
				$t('crowdxScreen.crowdfundingScale.bullets.1'),
				$t('crowdxScreen.crowdfundingScale.bullets.2'),
			]"
		/>
		<crowdx-about-crowded-hero />
		<home-wallet
			:title="$t('crowdxScreen.wallet.title')"
			:titleStyle="{ color: '#050535' }"
			:descriptionStyle="{
				color: '#050535',
				fontFamily: 'HKNova-Light, sans-serif',
			}"
			:extraTextStyle="{
				color: '#050535',
				fontFamily: 'HKNova-Light, sans-serif',
			}"
			:description="$t('crowdxScreen.wallet.description')"
			:extraText="$t('crowdxScreen.wallet.extraText')"
			imagePath="/images/sections/crowdx/bb-mobile.png"
			:hideOpenWalletPrompt="true"
		/>
		<details-section
			class="fees-section"
			:backgroundColor="'#FFFFFF'"
			:boxOptions="boxOptions"
			:feesTitle="$t('crowdxScreen.details.fees.title')"
			:feesSubTitle="$t('crowdxScreen.details.fees.subTitle')"
			:fees="fees"
		/>
		<warning-section
			:backgroundColor="'#757575'"
			:firstDescription="$t('crowdxScreen.warningSection.firstWarning')"
			:secondDescription="$t('crowdxScreen.warningSection.secondWarning')"
		/>
	</div>
</template>

<script>
import VideoSection from '@/components/sections/ebso/VideoSection';
import IntroductionSection from '@/components/sections/ebso/IntroductionSection';
import GoldCoverageSection from '@/components/sections/ebso/GoldCoverageSection';
import AuditAndStepsSection from '@/components/sections/ebso/AuditAndStepsSection';
import TokenDatasSection from '@/components/sections/ebso/TokenDatasSection';
import PartnersSection from '@/components/sections/ebso/PartnersSection';
import OtherProducts from '@/components/sections/OtherProducts';
import BsoAndEbsoSection from '@/components/sections/ebso/BsoAndEbsoSection';
import WarningSection from '@/components/sections/bit/WarningSection';
import DetailsSection from '@/components/sections/bit/DetailsSection';
import HomeWallet from '@/components/modules/home/HomeWallet';
import CrowdxWhitePaper from '@/components/sections/crowdx/CrowdxWhitePaper.vue';
import CrowdxAboutSection from '@/components/sections/crowdx/CrowdxAboutSection.vue';
import CrowdxUseCasesSection from '@/components/sections/crowdx/CrowdxUseCasesSection.vue';
import ChartComponent from '@/components/elements/ChartComponent';
import moment from 'moment';
import Api from '@/api';
import { mapGetters } from 'vuex';
import CrowdxAboutCrowdedHero from '../../components/sections/crowdx/CrowdxAboutCrowdedHero.vue';
import CrowdFundingAtScaleSection from '../../components/sections/crowdx/CrowdFundingAtScaleSection.vue';

export default {
	name: 'CrowdxScreen',
	props: {},
	components: {
		VideoSection,
		IntroductionSection,
		GoldCoverageSection,
		AuditAndStepsSection,
		TokenDatasSection,
		PartnersSection,
		OtherProducts,
		BsoAndEbsoSection,
		WarningSection,
		DetailsSection,
		HomeWallet,
		CrowdxWhitePaper,
		CrowdxAboutSection,
		CrowdxUseCasesSection,
		ChartComponent,
		CrowdxAboutCrowdedHero,
		CrowdFundingAtScaleSection,
	},
	data: () => ({
		chartDataLimit: 7,
		chartDataInterval: '1m',
		chartData: undefined,
		boxOptions: {
			//borderColor: '#ED8532',
			borderColor: '#FCBB11',
			backgroundColor: '#FFFFFF',
			titleColor: '#FFFFFF',
			descriptionColor: '#FFFFFF',
			background: '#F7F7F7',
		},
		fees: [
			{
				title: 'crowdxScreen.details.fees.parts.buying.title',
				values: [
					{
						value: '',
						label: 'crowdxScreen.details.fees.parts.buying.list.first.label',
					},
				],
			},
			{
				title: 'crowdxScreen.details.fees.parts.transfer.title',
				values: [
					{
						value: '',
						label: 'crowdxScreen.details.fees.parts.transfer.list.first.label',
					},
				],
			},
			{
				title: 'crowdxScreen.details.fees.parts.pay.title',
				values: [
					{
						value: '',
						label: 'crowdxScreen.details.fees.parts.pay.list.first.label',
					},
				],
			},
		],
	}),
	created() {},
	computed: {
		...mapGetters({
			getSelectedLanguage: 'settings/getSelectedLanguage',
		}),
		calculatedLastPrice() {
			if (this.chartData) {
				return this.chartData[this.chartData.length - 1].rate.toFixed(2);
			}
			return undefined;
		},
		refactoredData() {
			if (this.chartData) {
				return {
					labels: this.chartData.map((obj) => {
						moment.locale(this.getSelectedLanguage);
						const newDate = moment(new Date(obj.date))
							.format('MMM')
							.replace('.', '');
						return newDate.toLowerCase();
					}),
					tooltipLabel: (value) => `€${value.yLabel.toFixed(2)} / CrowdX`,
					datasets: [
						{
							data: this.chartData.map((obj) => obj.rate),
							borderColor: 'rgba(237, 133, 50, 1)',
							pointBackgroundColor: 'rgba(255, 255, 255, 1)',
							pointBorderColor: 'rgba(206, 35, 40, 1)',
							borderCapStyle: 'round',
							pointHoverBackgroundColor: '#fff',
							pointHoverBorderColor: 'rgba(206, 35, 40, 1)',
							pointHighlightFill: '#fff',
							pointHoverBorderWidth: 2,
							backgroundColor: 'transparent',
							pointColor: 'transparent',
							pointStrokeColor: 'rgba(206, 35, 40, 1)',
						},
					],
				};
			}
			return undefined;
		},
	},
	/* 	async mounted() {
		 		const response = await Api.get(
			`publicReferencePrice/CRDX?limit=${this.chartDataLimit}&interval=${this.chartDataInterval}`,
		);
		this.chartData = await response.json();

		const res = await Api.get('publicPrice');
		this.currentPrice = await res.json();

		let currentProduct = this.currentPrice.find((price) => {
			return price.asset === 'CRDX' && price.type === 'Buy';
		});

		if (currentProduct) {
			this.chartData[this.chartData.length - 1].rate = currentProduct.rate;
		}
	}, */
	mounted() {},
	methods: {},
};
</script>

<style lang="scss" scoped>
#crowdx-screen {
	.jumbotron {
		border-bottom: 1px solid $ebso-section-border-color;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			width: 100%;
			height: 704px;
			background-color: rgba(22, 16, 16, 0.75);
			z-index: 0;
			pointer-events: none;
		}

		&::v-deep {
			.content-wrapper {
				@media (max-width: $breakpoint-xs) {
					padding-top: 130px;
				}
			}

			.top-section {
				.logo {
					max-height: 75px;
				}
			}

			.bottom-section {
				flex-direction: column;
			}
		}
	}

	&::v-deep {
		#home-wallet {
			background-image: unset;
			margin-bottom: $margin-m;

			.content-container {
				background: linear-gradient(
					285.35deg,
					rgba(206, 35, 40, 0.4) 8.08%,
					rgba(237, 133, 50, 0.2) 39.68%,
					rgba(237, 133, 50, 0) 67.29%
				);
			}

			.wallet-image-wrapper {
				justify-content: end;

				@media (max-width: $breakpoint-md) {
					justify-content: center;
				}

				.wallet-image {
					margin-right: -50px;
					margin-bottom: 0px;

					@media (max-width: $breakpoint-lg) {
						margin-right: -100px;
					}

					@media (max-width: $breakpoint-md) {
						margin-right: 0px;
					}
				}
			}

			.wallet-row {
				flex-direction: row !important;

				.wallet-col {
					align-items: flex-start !important;

					@media (max-width: $breakpoint-sm) {
						align-items: center !important;
					}

					.title {
						text-align: left !important;

						@media (max-width: $breakpoint-sm) {
							text-align: center !important;
						}
					}

					.text {
						text-align: left !important;

						@media (max-width: $breakpoint-sm) {
							text-align: center !important;
						}
					}
				}
			}
		}

		.row {
			@media (max-width: $breakpoint-sm) {
				row-gap: 0px;
			}
		}

		.section-title {
			color: #26262b;
		}

		.section-sub-title {
			color: #26262b;
		}

		.bordered-box {
			padding: 15px 25px 15px 20px;

			.title {
				margin-bottom: 0px;
				color: #26262b;
				font-size: 16px;
				line-height: 30px;
			}

			.description-wrapper {
				.label {
					color: #26262b;
				}
			}
		}
	}

	.other-products {
		&::v-deep {
			.section-title {
				color: $blockstock-yellow;
			}
		}
	}

	.warning-section {
		border-bottom: 1px solid $ebso-section-border-color;
	}
}
</style>
